export const marketingDe = {
  // FreeMagnetPage
  'marketing.free.seo.title': 'Kostenloser Quickstart',
  'marketing.free.seo.description':
    'Hol dir den kostenlosen Grymwyrd Quickstart — die Regeln und ein One-Shot, den du noch heute Abend leiten kannst. Tritt ein ins Zwielicht.',
  'marketing.free.eyebrow': 'Deine kostenlose Passage',
  'marketing.free.heading': 'Tritt ein ins Zwielicht — kostenlos',
  'marketing.free.subheadLead': 'Der',
  'marketing.free.quickstartName': 'Grymwyrd Quickstart',
  'marketing.free.subheadTail':
    '— Grundregeln plus ein One-Shot-Abenteuer, das du noch heute Abend leiten kannst. Sag uns, wohin wir ihn schicken sollen.',
  'marketing.free.benefit.rules.title': 'Die Regeln',
  'marketing.free.benefit.rules.body': 'Alles, was du zum Spielen brauchst — verdichtet in einem Quickstart.',
  'marketing.free.benefit.oneShot.title': 'Ein One-Shot',
  'marketing.free.benefit.oneShot.body': 'Ein spielfertiges Horrorabenteuer für deinen ersten Abend.',
  'marketing.free.benefit.livingWorld.title': 'Lebendige Welt',
  'marketing.free.benefit.livingWorld.body': 'Verknüpft mit einer Enzyklopädie, Karten und wöchentlichen Drops.',
  'marketing.free.playInstead.heading': 'Lieber gleich spielen?',
  'marketing.free.playInstead.body':
    'Erschaffe deinen ersten Charakter und spiel eine 10-minütige Solo-Probe — kein Kauf, keine Verpflichtung.',
  'marketing.free.playInstead.cta': 'Charakter erschaffen',

  // LeadCaptureForm
  'marketing.leadForm.error.generic': 'Etwas ist schiefgelaufen. Versuch es gleich noch einmal.',
  'marketing.leadForm.ready': 'Dein kostenloser Quickstart ist bereit.',
  'marketing.leadForm.downloadCta': 'Quickstart herunterladen',
  'marketing.leadForm.alsoEmailed': 'Wir haben den Link auch an dein Postfach geschickt.',
  'marketing.leadForm.checkInbox': 'Schau in dein Postfach — dein kostenloser Quickstart ist unterwegs.',
  'marketing.leadForm.emailPlaceholder': 'du@beispiel.de',
  'marketing.leadForm.emailAriaLabel': 'E-Mail-Adresse',
  'marketing.leadForm.defaultCta': 'Schick mir den Quickstart',
  'marketing.leadForm.privacyNote':
    'Kein Spam — nur der Quickstart und gelegentlich ein Lore-Drop. Jederzeit abbestellbar.',
}
